import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { inject } from '@angular/core';

@Component({
  selector: 'app-mica-chat-mensaje-video',
  templateUrl: './mica-chat-mensaje-video.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mica-chat-mensaje-video.css',
})
export class MicaChatMensajeVideo {
  private sanitizer = inject(DomSanitizer);

  streamUrl = input.required<string | null>();
  caption = input<string>('');

  safeUrl = computed(() => {
    const url = this.streamUrl();
    if (!url) return null;
    return this.sanitizer.bypassSecurityTrustUrl(url);
  });
}
